import React from 'react';
import { Element } from 'react-scroll';

function Section(props) {
  const { label, schema: { title, description } } = props;
  if (!label && !title) {
    // See #312: Ensure compatibility with old versions of React.
    return <div />;
  }
  const capitalizeFirstLetter = str => (str && `${str.charAt(0).toUpperCase()}${str.slice(1)}`);
  return (
    <Element id={props.id} name={props.id} className="section-container">
      {capitalizeFirstLetter(title && label)}
      <div className="section-description">
        {description}
      </div>
    </Element>
  );
}


export default Section;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/formLib/SectionWidget.js